var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"formTitle","visible":_vm.open,"width":"50%","cancelText":"关闭"},on:{"close":_vm.onClose,"ok":_vm.submitForm}})
}
var staticRenderFns = []

export { render, staticRenderFns }